import React, { useMemo, useState } from 'react'
import { IconButton, Menu, MenuItem } from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert'

export const RowOptions = ({ rowPopupOptions, rowId }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = useMemo(() => Boolean(anchorEl), [anchorEl])

  const handleRowOptionsClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleRowOptionClose = () => {
    setAnchorEl(null)
  }

  return (
    <div key={rowId}>
      <IconButton onClick={handleRowOptionsClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleRowOptionClose}
      >
        {rowPopupOptions.map(option => {
          const { Icon, func, text } = option
          return (
            <MenuItem
              onClick={() => func(rowId)}
              key={`option-${text}-${rowId}`}
            >
              <div style={{ marginRight: 10, display: 'flex' }}>
                <Icon />
              </div>
              <div>{text || ''}</div>
            </MenuItem>
          )
        })}
      </Menu>
    </div>
  )
}
